import { defaultTheme, Theme } from '@surveycake/rc';
import { getTheme } from 'app/core/http';
import { Exception } from 'app/core/status';

function mergeTheme(origin: Theme, theme: Theme): Theme {
  return {
    ...origin,
    color: {
      ...origin.color,
      primary: {
        ...origin.color.primary,
        ...theme.color.primary
      },
      semantic: {
        ...origin.color.semantic,
        ...theme.color.semantic
      }
    },
    survey: {
      ...theme.survey
    }
  };
}

/**
 * To recursively get the theme.
 * Will return the theme data until anyone successfully fetched, or throw exception.
 */
async function get(
  theme?: string,
  ...others: Array<string | undefined>
): Promise<Theme> {
  if (!theme && others.length === 0) {
    throw new Exception('NOT_FOUND');
  }

  try {
    if (theme) {
      return await getTheme(theme);
    }

    return await get(...others);
  } catch (error) {
    return await get(...others);
  }
}

/**
 * To get the theme from theme names and merge the theme with default theme.
 */
export async function initialTheme(...themeNames: Array<string | undefined>) {
  try {
    /**
     * If the themes are not found, it will get the `surveycake` theme.
     */
    const theme = await get(...themeNames, 'surveycake');
    return mergeTheme(defaultTheme, theme);
  } catch (error) {
    throw new Exception('NOT_FOUND');
  }
}
